import { useSignal } from '@preact/signals-react'
import { useCallback, useEffect } from 'react'
import { postSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { BIOpenUrlModal, BIFormData, BIUrlId } from 'Pages/BusinessLogistics/BI/Page/@signals'
import { useToast } from '@hooks'

export default function useBIUrlModalSubmit(name) {

	const isLoading = useSignal(false)
	const { showToast } = useToast()

	const setIsLoading = () => isLoading.value = true

	const onSubmit = useCallback(() => {
		postSubmit(`${BACKEND_APIS.DASHBOARD}/save-filters`, { name, path: BIOpenUrlModal.value, payload: BIFormData.value })
			.then(({value}) => {
				showToast.success(`Successfully saved link with name: ${name}`)
				BIOpenUrlModal.value = false
				BIUrlId.value = value
				isLoading.value = false
			})
			.catch(() => {
				showToast.error(`Failed to save link with name: ${name}`)
				isLoading.value = false
			})
	}, [name])

	useEffect(() => {
		if (isLoading.value) onSubmit()
	}, [isLoading.value])


	return {
		isLoading: isLoading.value,
		setIsLoading,
	}
}